// THIS FILE IS GENERATED via packages/editor/editor-plugins/scripts/update-editor-plugins.ts. DO NOT MODIFY IT MANUALLY.
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
export { extensionPlugin } from '@atlaskit/editor-plugin-extension';
export type {
	CreateExtensionAPI,
	ExtensionPlugin,
	ExtensionPluginOptions,
	InsertOrReplaceExtensionType,
	RunMacroAutoConvert,
	RejectSave,
	ExtensionPluginDependencies,
	ExtensionState,
	ExtensionAction,
	ExtensionPluginActions,
} from '@atlaskit/editor-plugin-extension';
